import React from 'react';

const Error = () => {
    return (
        <div className="position-relative">
            <div className="position-absolute top-50 start-50 translate-middle">
                <h1>404 not found</h1>
            </div>
        </div>
    );
};

export default Error;